export default "__VITE_ASSET__ef1b8c91__"